module.exports = __webpack_public_path__ + "img/tutor-logo.10641efb.svg";